import { Filter, FilterService } from './Filter';
import { getLiveOccupancy as retrieveOccupancy, getFootfall as retrieveFootfall, getCrossings as retrieveCrossings } from '../assets/libs/broox/brooxCloudApi';
import { ChartInput } from './ChartInput';
import { AccountParams } from './AccountParams';

interface Occupancy {
  total: number,
  occupancy: ChartInput,
  entries: ChartInput,
  peakTimeHour: string,
  peakTimeValue: number,
  offPeakTimeHour: string,
  offPeakTimeValue: number
}

const getLiveOccupancy = async (filter: Filter, params: AccountParams): Promise<Occupancy> => {
  filter = FilterService.parse(filter);
  const data: any = await retrieveOccupancy(filter, params.host, params.token || params.id, params.apiKey);
  const result: Occupancy = {
    total: data.total,
    peakTimeHour: data.peakTime.label + ':00',
    peakTimeValue: data.peakTime.value,
    offPeakTimeHour: data.offPeakTime.label + ':00',
    offPeakTimeValue: data.offPeakTime.value !== Number.MAX_SAFE_INTEGER ? data.offPeakTime.value : 0,
    occupancy: { datasets: [{ data: [], backgroundColor: [] }], labels: [] },
    entries: { datasets: [{ data: [], backgroundColor: [ '#D9F8FC' ], barThickness: 30, borderRadius: 4, borderSkipped: false }], labels: [] },
  };
  data.entries.sort((a: any, b: any) => b.value - a.value);
  for(let i = 0; i < data.entries.length && i < 5; i++) {
    result.entries.labels.push(data.entries[i].label);
    result.entries.datasets[0].data.push(data.entries[i].value);
  }
  return result;
}

const getPreviousLiveOccupancy = async (filter: Filter, params: AccountParams): Promise<Occupancy> => {
  filter = FilterService.parse(filter);
  filter = FilterService.previous(filter);
  return await getLiveOccupancy(filter, params);
}

const getFootfall = async (filter: Filter, params: AccountParams): Promise<Occupancy> => {
  filter = FilterService.parse(filter);
  const data: any = await retrieveFootfall(filter, params.host, params.token || params.id, params.apiKey);
  const result: Occupancy = {
    total: data.total,
    peakTimeHour: data.peakTime.label + ':00',
    peakTimeValue: data.peakTime.value,
    offPeakTimeHour: data.offPeakTime.label + ':00',
    offPeakTimeValue: data.offPeakTime.value !== Number.MAX_SAFE_INTEGER ? data.offPeakTime.value : 0,
    occupancy: { datasets: [{ data: [], backgroundColor: [] }], labels: [] },
    entries: { datasets: [{ data: [], backgroundColor: [ '#FFD9C4' ], barThickness: 30, borderRadius: 4, borderSkipped: false }], labels: [] },
  };
  data.entries.sort((a: any, b: any) => b.value - a.value);
  for(let i = 0; i < data.entries.length && i < 5; i++) {
    result.entries.labels.push(data.entries[i].label);
    result.entries.datasets[0].data.push(data.entries[i].value);
  }
  return result;
}

const getPreviousFootfall = async (filter: Filter, params: AccountParams): Promise<Occupancy> => {
  filter = FilterService.parse(filter);
  filter = FilterService.previous(filter);
  return await getFootfall(filter, params);
}

const getCrossings = async (filter: Filter, params: AccountParams): Promise<Occupancy> => {
  filter = FilterService.parse(filter);
  const data: any = await retrieveCrossings(filter, params.host, params.token || params.id, params.apiKey);
  const result: Occupancy = {
    total: data.total,
    peakTimeHour: data.peakTime.label + ':00',
    peakTimeValue: data.peakTime.value,
    offPeakTimeHour: data.offPeakTime.label + ':00',
    offPeakTimeValue: data.offPeakTime.value !== Number.MAX_SAFE_INTEGER ? data.offPeakTime.value : 0,
    occupancy: { datasets: [{ data: [], backgroundColor: [] }], labels: [] },
    entries: { datasets: [{ data: [], backgroundColor: [ '#EDE2FF' ], barThickness: 30, borderRadius: 4, borderSkipped: false }], labels: [] },
  };
  data.entries.sort((a: any, b: any) => b.value - a.value);
  for(let i = 0; i < data.entries.length && i < 5; i++) {
    result.entries.labels.push(data.entries[i].label);
    result.entries.datasets[0].data.push(data.entries[i].value);
  }
  return result;
}

const getPreviousCrossings = async (filter: Filter, params: AccountParams): Promise<Occupancy> => {
  filter = FilterService.parse(filter);
  filter = FilterService.previous(filter);
  return await getCrossings(filter, params);
}

const hasValues = (occupancy: Occupancy) => {
  return occupancy.entries.datasets.some(d => d.data.length > 0);
}

export { Occupancy, getLiveOccupancy, getPreviousLiveOccupancy, getFootfall, getPreviousFootfall, getCrossings, getPreviousCrossings, hasValues };
